// Region Manager Reports page. The worker table, filters and report section are
// shared with SMO Lead Reports; their texts live under smoLead.
// Excel files stay Turkish.
const regionReports = {
  title: 'Region Manager Reports',
  breadcrumb: 'Reports / Region Manager Reports',

  stats: {
    totalRegions: 'Total Regions',
    centers: 'Sites in this Region',
    workers: 'Workers in this Region',
  },

  picker: {
    title: 'Region Managers',
    subtitle: 'Select a region to see the details',
    loading: 'Loading region managers...',
    emptyAdmin: 'No region has a region manager yet. You can define regions and region managers in the “Region Management” screen of the Site Management page.',
    emptyOwn: 'No region is assigned to you.',
    counts: '{{centers}} sites · {{cities}} cities',
    cityLegend: 'Cards reading “Region / City” are the view of a manager who is responsible for that city of the region only.',
    toggleHint: 'Click the selected region again to clear the selection.',
  },

  team: {
    title: '{{region}} — {{name}} - Workers',
    subtitle: 'Workers assigned at the sites in the region’s cities and their projects. The accent colour is the region’s colour.',
    loading: 'Loading workers...',
    noMatch: 'No worker matches your search.',
    empty: 'There are no workers in this region.',
  },

  filters: {
    search: 'Search worker, project, site or city...',
    help: 'Filters apply to the workers’ project assignments; a worker with no matching assignment drops out of the list. The search also covers city names.',
  },

  summary: {
    title: 'Operational Overview',
    text: 'Summary of the visits of the region’s workers in the selected period: quality, SLA, documentation and distance travelled.',
    status: '{{total}} visits analysed ({{home}} home / {{site}} site)',
    monthlyTrend: 'Monthly Visit Trend',
    workerChart: 'Visits per Worker',
    workerChartHelp: 'Shows the 12 workers with the most visits; the red bar is the number of visits with issues.',
  },

  toast: {
    managersError: 'Could not load the region managers!',
    workersError: 'Could not load the workers!',
    noVisits: 'This worker has no visits in this project.',
    excelDownloaded: 'Excel file downloaded',
    summaryExcel: 'Operational summary Excel downloaded',
  },
};

export default regionReports;
